import React from 'react';
export const SelectionStep = ({
  title,
  options,
  onSelect,
  multiSelect = false,
  selectedValues = [],
  onComplete
}) => {
  return <div className="bg-white rounded-lg shadow-lg p-6 animate-fade-in" data-id="element-26">
      <h2 className="text-xl font-bold mb-6 text-center" data-id="element-27">{title}</h2>
      <div className="grid grid-cols-2 gap-4" data-id="element-28">
        {options.map(option => <button key={option} className={`py-4 px-2 rounded-lg border-2 text-center transition-colors ${multiSelect ? selectedValues.includes(option) ? 'bg-red-500 text-white border-red-500' : 'bg-white text-gray-800 border-gray-300 hover:bg-gray-100' : 'bg-white text-gray-800 border-gray-300 hover:bg-gray-100'}`} onClick={() => onSelect(option)} data-id="element-29">
            {option}
          </button>)}
      </div>
      {multiSelect && <button className="w-full mt-8 py-3 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-colors" onClick={onComplete} data-id="element-30">
          Continue
        </button>}
    </div>;
};